import React from 'react';

const Facebook = () => {
  return (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.04678 5.02729V6.95872H8.95192L8.47305 9.93569H6.05476V17.1826C5.63975 17.2304 5.21674 17.2544 4.79374 17.2544C4.12333 17.2544 3.47686 17.1905 2.83837 17.0788V9.93569H0.20459V6.95872H2.83837V4.69208C2.83837 2.11417 4.37873 0.685547 6.72518 0.685547C7.85052 0.685547 9.03173 0.885075 9.03173 0.885075V3.4151H7.7308C6.44584 3.42308 6.04678 4.21321 6.04678 5.02729Z"
        fill="white"
      />
    </svg>
  );
};

export default Facebook;
